import styled from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';

export const Sup = styled<any, any>('sup')`
    ${propStyles};
`;



// WEBPACK FOOTER //
// ./src/Components/Superscript/StyledComponents/Sup.tsx